module.exports = __webpack_public_path__ + "svg/md-eye.svg";